export default "__VITE_ASSET__DjoiUCd6__"